import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractBinaryOperatorFormulaToken from "./AbstractBinaryOperatorFormulaToken.js";
import DivisionFormulaNode from "../formula/DivisionFormulaNode.js";

/**
 * Binary operation token representing a mathematical division.
 */
export default class DivisionFormulaToken extends AbstractBinaryOperatorFormulaToken {
	precedence() {
		return 1;
	}

	accept(visitor) {
		return visitor.visitDivisionFormulaToken(this);
	}

	_formulaNodeConstructor() {
		return DivisionFormulaNode;
	}

	static getLabel() {
		return _("Division");
	}

	static getType() {
		return "division";
	}
}
